import { boTypesApi } from "@src/api/bo/boTypes";
import { divisionApi } from "@src/api/dictionaries/divisions";
import { soApi } from "@src/api/so";
import type { BootstrapContext } from "../types";

/**
 * Загружает системные справочники сессии (типы подразделений, БО и СО) в bootstrap-контекст.
 */
export async function loadSystemData(ctx: BootstrapContext): Promise<void> {
    const [divisionTypes, boTypes, soTypes] = await Promise.all([
        divisionApi.loadDivisionTypes(),
        boTypesApi.loadBOTypes(),
        soApi.loadSOTypeListByFilter(),
    ]);

    if (divisionTypes.length === 0) {
        throw new Error("Не удалось загрузить типы подразделений. Приложение не может продолжить.");
    }

    if (boTypes.length === 0) {
        throw new Error("Не удалось загрузить типы БО. Приложение не может продолжить.");
    }

    if (soTypes.length === 0) {
        throw new Error("Не удалось загрузить типы СО. Приложение не может продолжить.");
    }

    ctx.divisionTypes = divisionTypes;
    ctx.boTypes = boTypes;
    ctx.soTypes = soTypes;
}
